import { useState } from 'react';
import { Link } from 'react-router-dom';
import useBlockInspect from '../../hooks/useBlockInspect';
import { IMG, pageBg } from '../../data/santaStages';
import GameBanner from '../../components/GameBanner/GameBanner';
import './SuspectsPage.css';

const SUSPECTS = [
  {
    image: 'img1.jpg',
    name: 'Cookie Monster',
    text: 'Cookie monster had a verbal spat with Santa 5 days ago when the elves complained about him! They told Santa that all the cookies packed for the children were eaten by the Cookie monster. The latter is often reprimanded by Santa for stealing supplies from Santa’s workshop under the pretext of being voraciously hungry.',
  },
  {
    image: 'img2.jpg',
    name: 'Jessica Claus',
    text: 'Not many have heard of her as she always takes the backseat with Father Claus taking all the limelight. The joke around town was that North Pole doesn’t recognise Jessica and this let the timid old lady to act furiously. She refused to make an attendance the whole last week to help out the elves.',
  },
  {
    image: 'img3.jpg',
    name: 'Elfie',
    text: 'This grumpy little Elf has always found Santa on the naughty list himself! He thinks all the elves are overworked and underpaid, especially since the pandemic has increased the number of good kids around town. He has often voiced his opinion and tried to create a trade union to fight for better perks!',
  },
  {
    image: 'img4.jpg',
    name: 'Grinch',
    text: 'A forever dream to make Christmas his own, Grinch has never liked the idea of Santa being the loved one. A few hours before Santa was announced kidnapped he was seen laughing out loud at the Tinsel Café quoting "Its going to be a Gristmas and not Christmas this year"',
  },
  {
    image: 'img5.jpg',
    name: 'Meisterburger BurgerMeister',
    text: "MB ran a profitable store exporting woollen items, placed adjoining Santa's workshop for years. In 2020 Santa had to expand his workshop and needed extra space. MB had to shutdown his store due to the low interest in his commodities as exports were stalled. This has created an envious, angry MB that has unfortunately turned down all offers to work in Santa's workshop.",
  },
];

export default function SuspectsPage() {
  const [index, setIndex] = useState(0);
  useBlockInspect();
  const suspect = SUSPECTS[index];

  const step = (delta) => {
    setIndex((current) => (current + delta + SUSPECTS.length) % SUSPECTS.length);
  };

  return (
    <div className="santa-suspects bg" style={pageBg('gamebg.jpg', 'bg1mob.jpg')}>
      <div className="container-fluid" style={{ marginTop: 0 }}>
        <GameBanner />
        <div className="row">
          <div className="col-sm-10 col-md-12 col-lg-12 col-xs-12 auto">
            <h3 className="log-title" style={{ textAlign: 'center' }}>
              <b>
                The COO at Santa&apos;s workshop has found 15 names who were scheduled to meet Santa in the last 3 days. After a thorough analysis of verbal and physical interactions through telephone records and CCTV footage, the list is now down to only 5. Could they have any wrong motives? Here are the 5 suspect profiles for you to analyse
              </b>
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="suspect-frame">
            <div className="col-sm-6 col-md-6 col-lg-6 col-xs-12 auto">
              <div className="santa-carousel">
                <div className="santa-carousel-slide">
                  <div className="col-sm-6 col-md-6 col-lg-6 col-xs-12 auto">
                    <img src={`${IMG}/${suspect.image}`} alt={suspect.name} style={{ width: '100%' }} />
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xs-12 auto">
                    <h4>{suspect.name}</h4>
                    <p style={{ fontSize: 12 }}>{suspect.text}</p>
                  </div>
                </div>
                <ol className="santa-carousel-indicators">
                  {SUSPECTS.map((item, itemIndex) => (
                    <li
                      key={item.name}
                      className={itemIndex === index ? 'active' : ''}
                      onClick={() => setIndex(itemIndex)}
                    />
                  ))}
                </ol>
                <button type="button" className="santa-carousel-control left" onClick={() => step(-1)} aria-label="Previous">
                  <i className="fa-solid fa-chevron-left" aria-hidden="true" />
                </button>
                <button type="button" className="santa-carousel-control right" onClick={() => step(1)} aria-label="Next">
                  <i className="fa-solid fa-chevron-right" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 text-center">
            <Link to="/rounds/1">
              <div className="button-login">Next</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
